const widgetName = 'socialNetworkWidget';
const fbWidth = 290;
const fbHeight = 380;

export default function facebookfeed() {
  const fbPageURL = $('.socialNetworkIconFacebook').attr('href');

  const facebookfeedContainer = `
    <div id="facebookfeedContainer" class="socialFeedContainer" style="display: none;" role="tabpanel" aria-labelledby="facebookfeedTab">
      <div class="fb-page" data-href="${fbPageURL}" data-width="${fbWidth}" data-adapt-container-width="true" data-height="${fbHeight}" data-small-header="true" data-hide-cover="false" data-show-facepile="false" data-show-posts="true">
        <div class="fb-xfbml-parse-ignore">
          <blockquote cite="${fbPageURL}"><a href="${fbPageURL}">Loading...</a></blockquote>
        </div>
      </div>
    </div>
  `;

  if (!isMobile) {
    $(`#${widgetName}`).append('<div class="socialTabContainer" role="tablist"></div>');
    $(`#${widgetName}`).append(facebookfeedContainer);
    $(`#${widgetName} #facebookfeedContainer`).show();
  }
}
